import { render, staticRenderFns } from "./OrderTooltip.vue?vue&type=template&id=767a37e6&"
import script from "./OrderTooltip.vue?vue&type=script&lang=js&"
export * from "./OrderTooltip.vue?vue&type=script&lang=js&"
import style0 from "./OrderTooltip.vue?vue&type=style&index=0&id=767a37e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports